import React, { useState } from 'react';
import { Button } from 'reactstrap';
import LocationForm from './LocationForm';

export default function LocationFormButton({
    id
}) {
    const [isUpdating, setIsUpdating] = useState(false);

    return (
        <div>
            <Button
                color="primary"
                size="sm"
                onClick={() => setIsUpdating(!isUpdating)}
            >
                Edit
      </Button>
            {isUpdating && (
                <LocationForm
                    id={id}
                    toggleModal={() => {
                        setIsUpdating(!isUpdating);
                    }}
                    formLabel="Edit Location"
                    visible={isUpdating}
                />
            )}
        </div>
    );
}

